import { ReactComponent as ConvertKit } from '../../../assets/integrations-icons/convertkit.svg';
import { ReactComponent as Mailchimp } from '../../../assets/integrations-icons/mailchimp.svg';
import { ReactComponent as MailPoet } from '../../../assets/integrations-icons/mailpoet.svg';
import { ReactComponent as Moosend } from '../../../assets/integrations-icons/moosend.svg';
import { ReactComponent as MailerLite } from '../../../assets/integrations-icons/mailerlite.svg';
import { ReactComponent as GetResponse } from '../../../assets/integrations-icons/getresponse.svg';
import { ReactComponent as Brevo } from '../../../assets/integrations-icons/brevo.svg';
import { ReactComponent as WebHook } from '../../../assets/integrations-icons/web-hook.svg';
import { ReactComponent as GoogleSheets } from '../../../assets/integrations-icons/google-sheets.svg';

export const icons = {
	ConvertKit,
	Mailchimp,
	MailPoet,
	Moosend,
	MailerLite,
	GetResponse,
	Brevo,
	WebHook,
	GoogleSheets,
	Email: 'email',
	Subscribe: 'admin-users',
	Login: 'admin-network',
};

export const integrations = [
	{
		async: false,
		type: 'Email',
		name: 'Email',
		apiUrl: '',
	},
	{
		async: false,
		type: 'Subscribe',
		name: 'Subscribe',
		apiUrl: '',
	},
	{
		async: false,
		type: 'Login',
		name: 'Login',
	},
	{
		async: true,
		type: 'ConvertKit',
		name: 'ConvertKit',
		apiUrl: 'https://www.convertkit.com/help/where-to-find-the-convertkit-api-key-groupid-and-documentation',
	},
	{
		async: true,
		type: 'GetResponse',
		name: 'GetResponse',
		apiUrl: 'https://www.getresponse.com/help/where-do-i-find-the-api-key.html',
	},
	{
		async: true,
		type: 'Mailchimp',
		name: 'Mailchimp',
		apiUrl: 'https://mailchimp.com/help/about-api-keys/',
	},
	{
		async: true,
		type: 'MailerLite',
		name: 'MailerLite',
		apiUrl: 'https://www.mailerlite.com/help/where-to-find-the-mailerlite-api-key-groupid-and-documentation',
	},
	{
		async: true,
		type: 'MailPoet',
		name: 'MailPoet',
	},
	{
		async: true,
		type: 'Moosend',
		name: 'Moosend',
		apiUrl: 'https://help.moosend.com/hc/en-us/articles/4403735862674-Find-the-API-key-of-your-account',
	},
	{
		async: true,
		type: 'Brevo',
		name: 'Brevo',
		apiUrl: 'https://developers.brevo.com/docs/getting-started',
	},
	{
		async: true,
		type: 'WebHook',
		name: 'WebHook',
		apiUrl: '',
		url: '',
		method: 'POST',
		additionalHeaders: false,
		fields: [],
		headers: [],
	},
	{
		async: true,
		type: 'GoogleSheets',
		name: 'GoogleSheets',
		spreadsheet: null,
		hasHeaderRow: false,
	},
];
